export class NecCacheable<T> {
  data: T;
  expireTime: number;

  constructor(data: T, expireTime) {
    this.data = data;
    this.expireTime = expireTime;
  }
}
